var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H11.25V5.99973C10.6233 5.52896 9.8442 5.25 9 5.25C6.92893 5.25 5.25 6.92893 5.25 9C5.25 9.8442 5.52896 10.6233 5.99973 11.25H2V5C2 3.34315 3.34315 2 5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25H11.25V9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.75V19C2 20.6569 3.34315 22 5 22H11.25V14.5417C11.1657 14.6808 11.0743 14.8176 10.975 14.95C10.2058 15.9756 8.98178 16.75 7 16.75C6.58579 16.75 6.25 16.4142 6.25 16C6.25 15.5858 6.58579 15.25 7 15.25C8.51822 15.25 9.29419 14.6911 9.775 14.05C10.0821 13.6405 10.2772 13.1978 10.4416 12.75H2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22V14.5417C12.8343 14.6808 12.9257 14.8176 13.025 14.95C13.7942 15.9756 15.0182 16.75 17 16.75C17.4142 16.75 17.75 16.4142 17.75 16C17.75 15.5858 17.4142 15.25 17 15.25C15.4818 15.25 14.7058 14.6911 14.225 14.05C13.9179 13.6405 13.7228 13.1978 13.5584 12.75H22V19C22 20.6569 20.6569 22 19 22H12.75Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 11.25H22V5C22 3.34315 20.6569 2 19 2H12.75V5.99973C13.3767 5.52896 14.1558 5.25 15 5.25C17.0711 5.25 18.75 6.92893 18.75 9C18.75 9.8442 18.471 10.6233 18.0003 11.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9V11.25H15.0021C16.2438 11.2489 17.25 10.2419 17.25 9C17.25 7.75736 16.2426 6.75 15 6.75C13.7574 6.75 12.75 7.75736 12.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.0988becc32080ef257ecba71f44008de.svg";
export { ForwardRef as ReactComponent };